import ApiService from '@/services/api';
import message from '@/utils/message';

// TYPES
export type TGetUserInfoResponse = any;
export type TLicenseStatus = 'valid' | 'unpaid' | 'expired' | 'blocked';

/**
 * How the company's licence was sold.
 *
 * 'stripe' is the self-service route: Stripe owns the subscription, the seat
 * count and the renewal. 'individual' is a contract agreed with sales, which
 * exists nowhere in Stripe and does not renew on its own - so nothing about it
 * can be bought, cancelled or managed in the app.
 */
export type TDealType = 'stripe' | 'individual';

export type TUserInfo = {
  id: number;
  full_name: string;
  email: string;
  role?: string;
  /** Whether this user holds one of the company's seats AND the license is usable. */
  has_license?: boolean;
  /** Status of the company license. 'unpaid' means an active trial. */
  license_status?: TLicenseStatus | null;
  /** ISO timestamp at which the company license expires. */
  expire_date?: string | null;
  /** How the company licence was sold. Decides what may be offered, and what is said instead. */
  deal_type?: TDealType | null;
  company?: {
    id?: number;
    name: string;
    email: string;
    phone: string;
    fax?: string;
    location?: string;
    address: string;
    postal_code?: string;
    logo?: string;
  };
};

export const getUserInfo = async (): Promise<TGetUserInfoResponse> => {
  try {
    const endpoint = `/v1/user/me/`;
    const response = await ApiService.get(endpoint);
    return response;
  } catch (error) {
    message.error(error.response.data.status_message);
    throw error.response;
  }
};
